<template>
  <div>
    <b-table
      v-if="servicosStatus.length > 0 && proposta.tipoProposta ==='semchecklist'"
      :items="servicosStatus"
      :fields="colunas"
      bordered
      hover
      tbody-tr-class="hide-row"
    >
      <template #cell(serviço)="{ item }">
        <span
          class="limite-texto"
        >{{ item.nome }}</span>
      </template>
      <template #cell(faturamento)="{ item }">
        <b-select
          v-model="item.statusFaturamento"
          :disabled="sucessoIntegracaoContrato() && sucessoIntegracao()"
          :options="['Aguardando', 'Liberado']"
          @change="updateStatus(item)"
        />
      </template>
      <template #cell(Ação)="{ item }">

        <info-checklist
          :item-id=" item.id ? item.id.toString() : ''"
          :item="item"
        />
      </template>
    </b-table>
    <div>
      <strong class="mr-50">Status integração empresa:</strong>
      <font-awesome-icon
        :icon="faRobot"
        :class="[{'sucesso-integracao': sucessoIntegracao()}, {'erro-integracao': erroIntegracao()}, {'pendente-integracao': pendenteIntegracao()}]"
        style="font-size:1.3rem !important;"
      />
      <span :class="[{'sucesso-integracao': sucessoIntegracao()}, {'erro-integracao': erroIntegracao()}, {'pendente-integracao': pendenteIntegracao()}]">
        {{ erroIntegracao() ? 'Erro' : pendenteIntegracao() ? 'Pendente' : 'Sucesso' }}</span>
    </div>
    <div class="mt-50">
      <b-textarea
        v-model="textoEmpresas"
        max-rows="3"
        :disabled="true"
      />
    </div>
    <div v-if="dataExecucao">
      <span style="font-size: 0.7rem;font-weight: 500;">Data: {{ data }}</span>
    </div>
    <div class="mt-1">
      <strong class="mr-50">Status integração proposta:</strong>
      <font-awesome-icon
        :icon="faRobot"
        :class="[{'sucesso-integracao': sucessoIntegracaoContrato()}, {'erro-integracao': erroIntegracaoContrato()}, {'pendente-integracao': pendenteIntegracaoContrato()}]"
        style="font-size:1.3rem !important;"
      />
      <span :class="[{'sucesso-integracao': sucessoIntegracaoContrato()}, {'erro-integracao': erroIntegracaoContrato()}, {'pendente-integracao': pendenteIntegracaoContrato()}]">
        {{ erroIntegracaoContrato() ? 'Erro' : pendenteIntegracaoContrato() ? 'Pendente' : 'Sucesso' }}</span>
    </div>
    <div class="mt-50">
      <b-textarea
        v-model="textoContrato"
        :disabled="true"
        no-resize
      />
    </div>

    <div v-if="dataExecucaoContrato">
      <span style="font-size: 0.7rem;font-weight: 500;">Data: {{ dataContrato }}</span>
    </div>

    <div
      v-if="emps.some(som => som.id === 0)"
      style="text-align: center;text-decoration: underline;margin-top: 0.25em;"
      :class="[{'disable-click': alteradoOmie}]"
    >
      <span
        style="cursor: pointer;"
        @click="alterarStatusContrato()"
      >Alterar o status para Sucesso manualmente!</span>
    </div>

    <div class="mt-1">
      <b-btn
        variant="success"
        size="sm"
        class="w-100"
        :disabled="desabilitarBotao()"
        @click="integrarManualmente"
      >
        Integrar com a Omie
      </b-btn>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faRobot,
} from '@fortawesome/free-solid-svg-icons'
// import { text } from '@fortawesome/fontawesome-svg-core'
import { getUserData } from '@/auth/utils'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'OmieIntegrationTab',
  components: {
    FontAwesomeIcon,
    InfoChecklist: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/checklist-proposta/shared/components/InfoChecklist.vue'),
  },
  props: {
    empresas: {
      type: Array,
      default: () => [],
    },
    dataExecucao: {
      type: String,
      default: null,
    },
    dataExecucaoContrato: {
      type: String,
      default: null,
    },
    alteradoContratoOmieManualmente: {
      type: Boolean,
      default: false,
    },
    contratante: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      colunas: [
        {
          key: 'Serviço', label: 'Serviço', thStyle: 'width: 500px; padding:5px', tdClass: 'row-table-faturamento',
        },
        {
          key: 'Faturamento', label: 'Faturamento', thStyle: 'width: 135px; padding: 5px', tdClass: 'row-table-faturamento',
        },
        {
          key: 'Ação', label: 'Ação', thStyle: 'width: 50px; padding: 5px', tdClass: 'column-acoes',
        },
      ],
      faRobot,
      emps: [],
      data: this.dataExecucao,
      dataContrato: this.dataExecucaoContrato,
      alteradoOmie: this.alteradoContratoOmieManualmente,
      contratanteProposta: this.contratante,
      servicoSelected: null,
      servicosStatus: [],
      textoEmpresas: '',
      textoContrato: '',
    }
  },
  computed: {
    ...mapGetters('proposta', ['proposta', 'getStatusProposta', 'getTodosServicos']),
  },
  watch: {
    empresas(value, oldValue) {
      if (value !== oldValue) {
        this.emps = value
      }
    },
    dataExecucao(value, oldValue) {
      if (value !== oldValue) {
        this.data = value
      }
    },
    dataExecucaoContrato(value, oldValue) {
      if (value !== oldValue) {
        this.dataContrato = value
      }
    },
    alteradoContratoOmieManualmente(value, oldValue) {
      if (value !== oldValue) {
        this.alteradoOmie = value
      }
    },
    contratante(value, oldValue) {
      if (value !== oldValue) {
        this.contratanteProposta = value
      }
    },
    empresasVinculadas(value, oldValue) {
      if (value !== oldValue) {
        this.emps = value
      }
    },
  },
  created() {
    this.emps = this.proposta.empresasVinculadas
    this.data = this.dataExecucao
    this.dataContrato = this.dataExecucaoContrato
    this.show()
  },
  updated() {
    // const mostrarBotaoOmie = this.mostrarIntegracaoOmie()
    this.textoEmpresas = this.getTextoEmpresas()
    this.textoContrato = this.getTextoContrato()
    // if (mostrarBotaoOmie && ((this.tipoProposta === 'semchecklist' && this.etiquetas.some(s => s.descricao === 'Aprovada')))) {
    // this.show()
    // }
    this.show()
  },
  methods: {
    show() {
      this.servicosStatus = this.getTodosServicos
      this.textoEmpresas = this.getTextoEmpresas()
      this.textoContrato = this.getTextoContrato()
    },
    updateStatus(value) {
      const servicoUpdate = {
        id: value.id,
        statusFaturamento: value.statusFaturamento,
        isPacoteServico: value.isServicoPacote,
      }
      api.atualizarStatusFaturamentoServico(servicoUpdate.id, servicoUpdate)
        .then(payload => {
          const index = this.servicosStatus.findIndex(i => i.id === payload.data.id)
          this.servicosStatus[index].usuCadastro = payload.data.usuAlteracaoStatusFaturamento
          this.servicosStatus[index].dataCadastro = payload.data.dataAlteracaoStatusFaturamento
        })
        .catch(err => {
          this.$handleError(err)
        })
    },
    getTextoEmpresa(value, msgContrato) {
      switch (value.statusOmie) {
        case 4:
          return `${value.cadastroFederal ?? value.inscricao} - Empresa disponível no banco de dados Omie.\n`
        case 2:
          return `${value.cadastroFederal ?? value.inscricao} - Criado novo cadastro na Omie!\n`
        case 3:
          return `${value.cadastroFederal ?? value.inscricao} - Erro: ${value.mensagemErroOmie}\n`
        case 1:
          return !msgContrato ? 'Aguardando CNPJ da empresa para iniciar a integração!' : msgContrato
        default:
          return `Status desconhecido (${value.statusOmie}) para a empresa ${value.cadastroFederal ?? value.inscricao}.\n`
      }
    },
    getTextoEmpresas() {
      let texto = ''
      if (this.emps && this.emps.length > 0) {
        this.emps.forEach(each => {
          if (each.empresaResumida.id > 0) {
            texto += this.getTextoEmpresa(each.empresaResumida, each.mensagemContrato)
          } else {
            texto += `${each.mensagemContrato}\n`
          }
        })
      } else if (this.contratanteProposta) {
        texto += this.getTextoEmpresa(this.contratanteProposta)
      }
      return texto
    },
    getTextoContrato() {
      let texto = ''
      if (this.emps && !this.emps.some(som => som.id === 0)) {
        this.emps.forEach(each => {
          if (each.eStatusOmieContrato === 2) {
            texto += `${each.numeroContrato} - ${each.mensagemContrato}\n`
          } else if (each.eStatusOmieContrato === 3) {
            texto += `${each.mensagemContrato}\n`
          } else if (each.eStatusOmieContrato === 1) {
            if (this.tipoProposta === 'semchecklist') {
              texto += `${each.mensagemContrato}\n`
            } else {
              texto += 'Aguardando integração da empresa para iniciar a integração do contrato!\n'
            }
          } else if (each.eStatusOmieContrato === 6) {
            texto += `${each.numeroContrato} - Ordem de Serviço unificada na Omie.\n`
          }
        })
      } else if (!this.alteradoOmie) {
        texto = 'Caso esse contrato já tenha sido integrado com a Omie, altere manualmente o status para Sucesso!'
      } else {
        texto = 'Status alterado manualmente para Sucesso.'
      }
      return texto
    },
    integrarManualmente() {
      if (getUserData().permissaoOmie) {
        this.$confirmar('', 'Deseja realizar a integração com a Omie agora?', 'question', 'danger')
          .then(result => {
            if (result.value) {
              this.$isLoading(true)
              api.integrarEmpresasManualmenteOmie(this.proposta.id, this.emps)
                .then(payload => {
                  this.emps = payload.data.empresasVinculadas
                  this.data = payload.data.dataExecucaoOmie
                  this.dataContrato = payload.data.dataExecucaoContratoOmie
                  this.show()
                  const msgfeedback = 'Para integrar essa Ordem de Serviço é necessário que todos os serviços estejam com o status de faturamento Liberado!'
                  if (this.emps[0].mensagemContrato === msgfeedback) {
                    this.$erro(msgfeedback)
                  }
                })
                .catch(err => {
                  this.$handleError(err)
                })
                .finally(() => {
                  this.$isLoading(false)
                })
            }
          })
      } else {
        this.$erro('Você não tem permissão para realizar essa ação!')
      }
    },
    desabilitarBotao() {
      return this.getStatusProposta === 4 || ((!this.emps.some(som => som.empresaResumida.statusOmie === 3 || som.empresaResumida.statusOmie === 1)
        && !this.emps.some(som => som.eStatusOmieContrato === 3 || som.eStatusOmieContrato === 1) && !this.emps.some(som => som.id === 0))
        || this.alteradoOmie)
    },
    sucessoIntegracao() {
      if (this.emps.some(s => s.empresaResumida.id > 0)) {
        return !this.emps.some(som => som.empresaResumida.statusOmie === 3 || som.empresaResumida.statusOmie === 1)
      }
      return false
    },
    erroIntegracao() {
      return this.emps.some(som => som.empresaResumida.statusOmie === 3)
    },
    pendenteIntegracao() {
      if (this.emps.some(s => s.empresaResumida.id > 0)) {
        return this.emps.some(som => som.empresaResumida.statusOmie === 1)
      }
      return true
    },
    sucessoIntegracaoContrato() {
      return !this.emps.some(som => som.eStatusOmieContrato === 3 || som.eStatusOmieContrato === 1) || this.alteradoOmie
    },
    erroIntegracaoContrato() {
      return this.emps.some(som => som.eStatusOmieContrato === 3)
    },
    pendenteIntegracaoContrato() {
      return this.emps.some(som => som.eStatusOmieContrato === 1) || (this.emps.some(som => som.id === 0) && !this.alteradoOmie)
    },
    alterarStatusContrato() {
      this.$confirmarHtml('', 'Ao alterar o status da proposta para Sucesso não será possível reverter a ação!<br>Tem certeza que deseja continuar?', 'question', 'danger')
        .then(result => {
          if (result.value) {
            api.alterarStatusSucessoManualmente(this.proposta.id)
              .then(() => {
                this.$router.go()
              })
          }
        })
    },

    // mostrarIntegracaoOmie() {
    //   return (this.getStatusProposta === 8 || this.getStatusProposta === 9 || this.getStatusProposta === 4)
    //     && ((this.tipoProposta === 'semchecklist' && this.semContratante && this.propostaContratanteDetails
    //       && this.propostaContratanteDetails.statusOmie !== 0)
    //       || (this.empresasVinculadas && this.empresasVinculadas.length > 0
    //         && !this.empresasVinculadas.some(som => som.empresaResumida.statusOmie === 0)
    //         && ((this.tipoProposta === 'semchecklist' && this.existeCadastroOmie)
    //           || (this.tipoProposta !== 'semchecklist' && this.geraContrato))))
    // },

  },
}
</script>

<style lang="scss">

.container-table {
min-height: 70vh;
overflow-y: auto;
margin-bottom: 1rem;

}

.sucesso-integracao {
  color: #28c76f;
}

.erro-integracao {
  color: #ea5455;
}

.pendente-integracao {
  color: #ffc107;
}

.disable-click {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.list-servico {
  border: 1px solid;
}

.btn-info button {
  height: 27px;
}

.row-table-faturamento{
  padding: 5px !important;
}

.column-acoes {
  padding: 5px 5px 5px 15px !important;
}
</style>
